const { escapeHtml, H, keyCode, parsePx } = Slick;export {
     escapeHtml, H, keyCode, parsePx
};